import React from 'react';

function ShirtFolded(props: object) {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 8L15 3.5L16.5 5V10.25C16.5001 10.3926 16.4595 10.5322 16.383 10.6525C16.3066 10.7728 16.1974 10.8689 16.0683 10.9294C15.9392 10.9899 15.7956 11.0123 15.6542 10.9941C15.5128 10.9759 15.3795 10.9178 15.27 10.8266L12 8Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.73 10.8247C8.62058 10.9158 8.48748 10.9739 8.34626 10.9922C8.20504 11.0105 8.06153 10.9882 7.93252 10.9279C7.80351 10.8676 7.69432 10.7719 7.61773 10.6518C7.54114 10.5318 7.5003 10.3924 7.5 10.25V5L9 3.5L12 8L8.73 10.8247Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 8V20.75"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.5 5H18.75C18.9489 5 19.1397 5.07902 19.2803 5.21967C19.421 5.36032 19.5 5.55109 19.5 5.75V20C19.5 20.1989 19.421 20.3897 19.2803 20.5303C19.1397 20.671 18.9489 20.75 18.75 20.75H5.25C5.05109 20.75 4.86032 20.671 4.71967 20.5303C4.57902 20.3897 4.5 20.1989 4.5 20V5.75C4.5 5.55109 4.57902 5.36032 4.71967 5.21967C4.86032 5.07902 5.05109 5 5.25 5H7.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 3.5H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ShirtFolded;
